const fs = {
  writeFile: async () => null,
  DocumentDirectoryPath: "",
}
export default fs
